/* 请求接口地址管理 - 使用统一配置 */
import { BASE_URL } from '@/config'

export var IP = BASE_URL
export var IP2 = BASE_URL

//http://211.159.158.96:8080/medisyn-hub/sys/login

  // process.env.NODE_ENV === "development"
  //   ? "/proxy-server" //本地代理
  //   : "https://qhzy-api.shzskx.cn"; //线上接口地址   http://124.223.76.2:6689 https://qhzy-api.shzskx.cn
